export const bookingHasExtras = (params: string): boolean => {
    const q = new URLSearchParams(params);

    // Check the new semicolon-separated br parameter format
    const brValue = q.get("br");
    if (brValue && brValue.includes("|")) {
        return true;
    }

    return false;
};
